import { baseUrl, httpClient } from 'src/pages/admin/providers/AppDataProvider';
import type {
  ApiResponse,
  MatchDataKpi,
  MatchStageParam,
  MatchSyncStatus,
  PatchWorldCupMatchPayload,
  RawMatchesByStage,
  WorldCupMatch,
} from './types';
import { normalizeMatchesByStage } from './utils';

const resourceBase = 'world-cup/match-data';

function unwrap<T>(json: ApiResponse<T> | T): T {
  if (json && typeof json === 'object' && 'data' in json) {
    return (json as ApiResponse<T>).data;
  }

  return json as T;
}

async function request<T>(path: string, options: RequestInit = {}): Promise<T> {
  const { json } = await httpClient(`${baseUrl}/${resourceBase}${path}`, options as any);

  return unwrap<T>(json);
}

function buildMatchesPath(stage?: MatchStageParam) {
  if (!stage) return '/matches';

  return `/matches?${new URLSearchParams({ stage }).toString()}`;
}

export const worldCupMatchDataApi = {
  getKpi(signal?: AbortSignal) {
    return request<MatchDataKpi>('/kpi', {
      method: 'GET',
      signal,
    } as any);
  },

  async getMatches(stage?: MatchStageParam, signal?: AbortSignal) {
    const data = await request<RawMatchesByStage>(buildMatchesPath(stage), {
      method: 'GET',
      signal,
    } as any);

    return normalizeMatchesByStage(data);
  },

  // 页面暂不展示，但保留接口能力，后续产品恢复手动同步时可直接使用
  resync() {
    return request<MatchSyncStatus>('/resync', {
      method: 'POST',
    });
  },

  getSyncStatus(signal?: AbortSignal) {
    return request<MatchSyncStatus>('/sync-status', {
      method: 'GET',
      signal,
    } as any);
  },

  patchMatch(matchId: string, payload: PatchWorldCupMatchPayload) {
    return request<WorldCupMatch>(`/matches/${matchId}`, {
      method: 'PATCH',
      body: JSON.stringify(payload),
    });
  },
};
